module.exports=function(n){var r=!String(n).split(".")[1];return 1==n&&r?"one":"other"}